import { forwardRef } from 'react';

export const BuildingInCartIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.17676 37.571C2.17676 37.2547 2.43318 36.9983 2.74949 36.9983H40.9313C41.2476 36.9983 41.504 37.2547 41.504 37.571C41.504 37.8873 41.2476 38.1438 40.9313 38.1438H2.74949C2.43318 38.1438 2.17676 37.8873 2.17676 37.571Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.763672 11.4165C0.763672 11.1002 1.02009 10.8438 1.3364 10.8438H6.26185C6.44581 10.8438 6.61857 10.9321 6.72623 11.0813L10.8881 16.8467C10.9556 16.9404 10.9933 17.0522 10.9962 17.1677L11.2635 27.8968C11.2636 27.9015 11.2637 27.9063 11.2637 27.911V32.3783H34.0964C34.4127 32.3783 34.6691 32.6347 34.6691 32.951C34.6691 33.2673 34.4127 33.5238 34.0964 33.5238H10.6909C10.3746 33.5238 10.1182 33.2673 10.1182 32.951V27.9182L9.85554 17.3734L5.96892 11.9892H1.3364C1.02009 11.9892 0.763672 11.7328 0.763672 11.4165Z"
        />
        <path d="M10.6533 34.822C11.7288 34.822 12.6006 33.9502 12.6006 32.8748C12.6006 31.7993 11.7288 30.9275 10.6533 30.9275C9.57788 30.9275 8.70605 31.7993 8.70605 32.8748C8.70605 33.9502 9.57788 34.822 10.6533 34.822Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6528 31.5002C9.89367 31.5002 9.27827 32.1156 9.27827 32.8747C9.27827 33.6339 9.89367 34.2493 10.6528 34.2493C11.412 34.2493 12.0274 33.6339 12.0274 32.8747C12.0274 32.1156 11.412 31.5002 10.6528 31.5002ZM8.13281 32.8747C8.13281 31.483 9.26106 30.3547 10.6528 30.3547C12.0446 30.3547 13.1728 31.483 13.1728 32.8747C13.1728 34.2665 12.0446 35.3947 10.6528 35.3947C9.26106 35.3947 8.13281 34.2665 8.13281 32.8747Z"
        />
        <path d="M33.5234 34.822C34.5989 34.822 35.4707 33.9502 35.4707 32.8748C35.4707 31.7993 34.5989 30.9275 33.5234 30.9275C32.448 30.9275 31.5762 31.7993 31.5762 32.8748C31.5762 33.9502 32.448 34.822 33.5234 34.822Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.5239 31.5002C32.7648 31.5002 32.1494 32.1156 32.1494 32.8747C32.1494 33.6339 32.7648 34.2493 33.5239 34.2493C34.2831 34.2493 34.8985 33.6339 34.8985 32.8747C34.8985 32.1156 34.2831 31.5002 33.5239 31.5002ZM31.0039 32.8747C31.0039 31.483 32.1322 30.3547 33.5239 30.3547C34.9157 30.3547 36.0439 31.483 36.0439 32.8747C36.0439 34.2665 34.9157 35.3947 33.5239 35.3947C32.1322 35.3947 31.0039 34.2665 31.0039 32.8747Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6768 4.50559C12.6768 4.18928 12.9332 3.93286 13.2495 3.93286H33.944C34.2603 3.93286 34.5168 4.18928 34.5168 4.50559V28.7892C34.5168 29.1055 34.2603 29.3619 33.944 29.3619H13.2495C12.9332 29.3619 12.6768 29.1055 12.6768 28.7892V4.50559ZM13.8222 5.07832V28.2165H33.3713V5.07832H13.8222Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9678 7.17844C14.9678 6.86213 15.2242 6.60571 15.5405 6.60571H18.6714C18.9877 6.60571 19.2441 6.86213 19.2441 7.17844V11.5312C19.2441 11.8475 18.9877 12.1039 18.6714 12.1039H15.5405C15.2242 12.1039 14.9678 11.8475 14.9678 11.5312V7.17844ZM16.1132 7.75117V10.9584H18.0987V7.75117H16.1132Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0391 7.17844C21.0391 6.86213 21.2955 6.60571 21.6118 6.60571H24.7427C25.059 6.60571 25.3154 6.86213 25.3154 7.17844V11.5312C25.3154 11.8475 25.059 12.1039 24.7427 12.1039H21.6118C21.2955 12.1039 21.0391 11.8475 21.0391 11.5312V7.17844ZM22.1845 7.75117V10.9584H24.17V7.75117H22.1845Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1475 7.17844C27.1475 6.86213 27.4039 6.60571 27.7202 6.60571H30.8511C31.1674 6.60571 31.4238 6.86213 31.4238 7.17844V11.5312C31.4238 11.8475 31.1674 12.1039 30.8511 12.1039H27.7202C27.4039 12.1039 27.1475 11.8475 27.1475 11.5312V7.17844ZM28.2929 7.75117V10.9584H30.2784V7.75117H28.2929Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9678 13.8984C14.9678 13.5821 15.2242 13.3257 15.5405 13.3257H18.6714C18.9877 13.3257 19.2441 13.5821 19.2441 13.8984V18.2511C19.2441 18.5674 18.9877 18.8239 18.6714 18.8239H15.5405C15.2242 18.8239 14.9678 18.5674 14.9678 18.2511V13.8984ZM16.1132 14.4711V17.6784H18.0987V14.4711H16.1132Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0391 13.8984C21.0391 13.5821 21.2955 13.3257 21.6118 13.3257H24.7427C25.059 13.3257 25.3154 13.5821 25.3154 13.8984V18.2511C25.3154 18.5674 25.059 18.8239 24.7427 18.8239H21.6118C21.2955 18.8239 21.0391 18.5674 21.0391 18.2511V13.8984ZM22.1845 14.4711V17.6784H24.17V14.4711H22.1845Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1475 13.8984C27.1475 13.5821 27.4039 13.3257 27.7202 13.3257H30.8511C31.1674 13.3257 31.4238 13.5821 31.4238 13.8984V18.2511C31.4238 18.5674 31.1674 18.8239 30.8511 18.8239H27.7202C27.4039 18.8239 27.1475 18.5674 27.1475 18.2511V13.8984ZM28.2929 14.4711V17.6784H30.2784V14.4711H28.2929Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9678 20.5801C14.9678 20.2637 15.2242 20.0073 15.5405 20.0073H18.6714C18.9877 20.0073 19.2441 20.2637 19.2441 20.5801V25.2764C19.2441 25.5927 18.9877 25.8491 18.6714 25.8491H15.5405C15.2242 25.8491 14.9678 25.5927 14.9678 25.2764V20.5801ZM16.1132 21.1528V24.7037H18.0987V21.1528H16.1132Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0391 20.5801C21.0391 20.2637 21.2955 20.0073 21.6118 20.0073H24.7427C25.059 20.0073 25.3154 20.2637 25.3154 20.5801V28.7128C25.3154 29.0291 25.059 29.2855 24.7427 29.2855H21.6118C21.2955 29.2855 21.0391 29.0291 21.0391 28.7128V20.5801ZM22.1845 21.1528V28.14H24.17V21.1528H22.1845Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1475 20.5801C27.1475 20.2637 27.4039 20.0073 27.7202 20.0073H30.8511C31.1674 20.0073 31.4238 20.2637 31.4238 20.5801V25.2764C31.4238 25.5927 31.1674 25.8491 30.8511 25.8491H27.7202C27.4039 25.8491 27.1475 25.5927 27.1475 25.2764V20.5801ZM28.2929 21.1528V24.7037H30.2784V21.1528H28.2929Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6387 2.86374C12.6387 2.54743 12.8951 2.29102 13.2114 2.29102H33.9059C34.2223 2.29102 34.4787 2.54743 34.4787 2.86374V4.50556C34.4787 4.82187 34.2223 5.07829 33.9059 5.07829H13.2114C12.8951 5.07829 12.6387 4.82187 12.6387 4.50556V2.86374ZM13.7841 3.43647V3.93283H33.3332V3.43647H13.7841Z"
        />
      </svg>
    );
  },
);
